import { render, staticRenderFns } from "./ElementUiMoney.vue?vue&type=template&id=79d19840&"
import script from "./ElementUiMoney.vue?vue&type=script&lang=js&"
export * from "./ElementUiMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports